export default function addBlankTargets(string: string) {
    return string?.replace(/<a/g, '<a target="_blank"');
}
